import { buildApiUrl, getApiHeaders } from '../../../config/api';
import { AclNode, CreateAclNodePayload, UpdateAclNodePayload } from '../types';

export const aclApi = {
  /**
   * List all ACL nodes
   */
  list: async (params?: Record<string, any>) => {
    const searchParams = new URLSearchParams();
    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined) searchParams.append(key, String(value));
      });
    }

    const response = await fetch(buildApiUrl(`/api/admin/firewall/acl?${searchParams.toString()}`), {
      headers: getApiHeaders(),
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.error || 'Failed to fetch ACL rules');
    }

    return response.json();
  },

  /**
   * Get an ACL node by ID
   */
  getById: async (id: number) => {
    const response = await fetch(buildApiUrl(`/api/admin/firewall/acl/${id}`), {
      headers: getApiHeaders(),
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.error || 'Failed to fetch ACL rule');
    }

    return response.json();
  },

  /**
   * Create a new ACL node
   */
  create: async (payload: CreateAclNodePayload) => {
    const response = await fetch(buildApiUrl('/api/admin/firewall/acl'), {
      method: 'POST',
      headers: getApiHeaders(),
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.error || 'Failed to create ACL rule');
    }

    return response.json();
  },

  /**
   * Update an existing ACL node
   */
  update: async (id: number, payload: UpdateAclNodePayload) => {
    const response = await fetch(buildApiUrl(`/api/admin/firewall/acl/${id}`), {
      method: 'PUT',
      headers: getApiHeaders(),
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.error || 'Failed to update ACL rule');
    }

    return response.json();
  },

  /**
   * Delete an ACL node
   */
  delete: async (id: number) => {
    const response = await fetch(buildApiUrl(`/api/admin/firewall/acl/${id}`), {
      method: 'DELETE',
      headers: getApiHeaders(),
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.error || 'Failed to delete ACL rule');
    }
  },

  /**
   * Force synchronization with FreeSWITCH
   */
  sync: async () => {
    const response = await fetch(buildApiUrl('/api/admin/firewall/acl/sync'), {
      method: 'POST',
      headers: getApiHeaders(),
      body: JSON.stringify({}),
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.error || 'Failed to sync ACL rules');
    }

    return response.json();
  },
};
